import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/SchoolOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗
import AddressDialog from "@pages/SchoolOrder/components/AddressDialog/index.vue" // 选择收货地址弹窗
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式
import addClass from "@pages/SchoolOrder/components/addClass/index.vue" // 创建班级
/*联动说明
1、切换代理商时，园所，项目，套餐，收货地址，联系人要重置
2、切换项目时，园所，套餐，收货地址，联系人要重置
3、切换园所时，套餐，收货地址，联系人要重置
获取代理商后》》
//获取续班套餐 getPackages(agentId)
// 获取续班的套餐  getContinuePackages(SchoolId, ProjectType)
// 获取套餐资源包下拉明细 getDetailsPackage(PackageId)

*/
export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        payTypeInfo,
        addClass
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {
        // 获取寄送方式
        this.getPay(8);
        this.getPay(9);

    },
    data() {
        return {
            num: 1,
            step: 1, //步数 
            agent: '',
            loading: false,
            school: '',
            transportList: [], //寄送方式
            PayList: [], //寄送支付方式
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false, //弹窗显示true
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            isDelShow: [false],
            payList: [{}],
            packagesOne: true, // true显示开课配置资源包样式
            GoodsListNum: [{
                Num: 0,
                List: [{
                    ProId: "",
                    ProNum: 30
                }]
            }],
            ProjectTypes: [], //续订项目资源包
            ContinuePackages: [], //续订套餐
            detailsPackages: [], //下拉资源包明细
            titleNum: '续订班级数',
            package3Details: [], //套餐三续资源包列表
            //套餐二列表数据
            Packages: [],
            boxData: [], //存储资源包数据
            classList: [], //班级列表
            ClassNum: 1,
            //支付对象  (除了亲子活动没有，其余都要选择)
            PayObject: [{
                Id: 0,
                label: "园所"
            }, {
                Id: 1,
                label: "代理商"
            }],
            AddUnitprice: 88, //单班续、全园续新增一本书价格
            UnitPrice1: 5500, //单班续
            UnitPrice2: 15800, //全园续单价
            UnitPrice3: 16800, //套餐一续、套餐二续单价
            UnitPrice4: 33600, //套餐三续单价
            UnitPriceHiA: 3500,
            PayObjectId: "", //存储下发支付对象ID
            ClassId: "", //存储班级ID
            ClassLists: [],
            openClassList: [{
                ClassId: '',
                ClassLists: this.ClassLists
            }],
            schoolConsignee: this.getSchoolConsignee()
        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
                "OrderId": 0,
                "AgentId": 0,
                "SchoolId": 0,
                "ProjectType": 0,
                "PackageId": '',
                "ClassNum": 1,
                "OrderPrice": 0, //资源包价格
                OrderPostPrice: '', //邮费
                "SchoolConsigneeId": 0,
                "SendMode": 223, //物流   D55续为默认快递221
                "PayMode": 222,
                "ProList": [{
                    "Num": 0,
                    "List": [{
                        "ProId": 0,
                        "ProNum": 0
                    }]
                }],
                "TVList": [],
                "ListMeetPay": [],
                "ClassId": "",
                "PayObject": "",
                "OrderRemark": "",
                ClassList: [],
                TimeStamp: '',

            });
        },
        // 园所地址
        getSchoolConsignee() {
            return cloneDeep({
                ConsigneeProvId: '',
                ConsigneeCityId: '',
                ConsigneeAreaId: '',
                Consignee: '',
                ConsigneeAddress: '',
                ConsigneeTel: ''
            })
        },
        // 续班订单 切换项目
        changeProjectType(val) {
            this.school = "";
            this.form.SchoolId = "";
            this.ConsigneeList = "";
            this.ConsigneeListName = "";
            this.ContinuePackages = [];
            this.GoodsListNum = [{
                Num: 0,
                List: [{
                    ProId: "",
                    ProNum: 30
                }]
            }];
            this.form.PackageId = '';
        },
        // 选择套餐
        changeValue(val) {
            // 切换titleNum 和packagesOne
            if (this.form.ProjectType == 2) {
                // hi ABC套餐 表格布局
                this.packagesOne = false
                this.titleNum = "订购套餐数";
            } else if (val == 405) {
                //套餐三（续）
                this.packagesOne = false
                this.titleNum = "订购套餐数";

            } else {
                // 套餐二403  套餐三404 亲子1151
                this.packagesOne = true
                this.titleNum = "续订班级数";
            }
            if (val == 1151) {
                // 亲子
                this.getClassId(this.form.SchoolId); //获取班级列表
            }
            if (val == 5042) {
                this.form.SendMode = 221
            } else {
                this.form.SendMode = 223
            }
            if (this.showData.PackageId !== val) {
                console.log('xiugai')
                this.getDetailsPackage(val);
                this.form.ClassNum = 1;
                this.openClassList = [{
                    ClassId: '',
                    ClassLists: this.ClassLists
                }]
                this.form.PayObject = ''; //清空支付对象选择
                this.form.ClassId = ""; //清空班级选择
                // 添加续订套餐
                switch (val) {
                    case 405:
                        this.GoodsListNum = [{
                            Num: 25,
                            List: [{
                                ProId: "",
                                ProNum: 0,
                                title: "配置美师英语学习材料包"
                            }, {
                                ProId: "",
                                ProNum: 0,
                                title: "配置思维导图学习材料包"
                            }, {
                                ProId: "",
                                ProNum: 0,
                                title: "配置艺术亲子活动材料包"
                            }]
                        }];
                        break;
                    case 1151:
                        this.GoodsListNum = [{
                            Num: 0,
                            List: [{
                                ProId: "",
                                ProNum: 5
                            }]
                        }];
                        break;
                    default:
                        this.GoodsListNum = [{
                            Num: 0,
                            List: [{
                                ProId: "",
                                ProNum: 25
                            }]
                        }];
                }
            } else {
                // 修改切换重新赋值数据
                this.form.PayObject = this.PayObjectId;
                this.form.ClassId = this.ClassId;
                this.form.ClassNum = this.ClassNum;
                if (this.form.ProjectType == 2) {
                    this.Packages = this.boxData

                } else {
                    this.GoodsListNum = cloneDeep(this.boxData);
                }


            }



        },
        // 选择支付对象
        changeObj(val) {
            if (val === 0) {
                // 园所续班价
                this.UnitPrice1 = 5500; //单班续401
                this.AddUnitprice = 68; //新增单价
                this.UnitPrice2 = 15800; //全园续单价
                this.UnitPrice3 = 16800; //套餐一续、套餐二续单价
                this.UnitPrice4 = 33600; //套餐三续单价
                this.UnitPriceHiA = 3750 //HiA
            } else if (val == 1) {
                // 代理商续班价
                this.UnitPrice1 = 5000; //单班续
                this.AddUnitprice = 38; //新增单价
                this.UnitPrice2 = 12800; //C套餐(全园续)单价  代理商订购价改为12800
                this.UnitPrice3 = 14300; //套餐一续、套餐二续单价
                this.UnitPrice4 = 28600; //套餐三续单价
                this.UnitPriceHiA = 3000 //HiA399
            }
        },
        // 开班数
        changeNum(val) {
            if (val > this.form.ClassNum) {
                // 加
                let len = val - this.form.ClassNum

                switch (this.form.PackageId) {
                    case 405:
                        for (let i = 0; i < len; i++) {
                            this.GoodsListNum.push({
                                Num: 25,
                                List: [{
                                    ProId: "",
                                    ProNum: 0,
                                    title: "配置美师英语学习材料包"
                                }, {
                                    ProId: "",
                                    ProNum: 0,
                                    title: "配置思维导图学习材料包"
                                }, {
                                    ProId: "",
                                    ProNum: 0,
                                    title: "配置艺术亲子活动材料包"
                                }]
                            });
                        }
                        break;
                    case 1151:
                        for (let i = 0; i < len; i++) {
                            this.GoodsListNum.push({
                                Num: 0,
                                List: [{
                                    ProId: "",
                                    ProNum: 5
                                }]
                            });
                        }

                        break;
                    default:
                        for (let i = 0; i < len; i++) {
                            this.GoodsListNum.push({
                                Num: 0,
                                List: [{
                                    ProId: "",
                                    ProNum: 25
                                }]
                            });
                            this.openClassList.push({
                                ClassId: '',
                                ClassLists: this.ClassLists
                            })
                        }
                }


            } else {
                //减
                let len = this.form.ClassNum - val
                for (let i = 0; i < len; i++) {
                    this.GoodsListNum.pop();
                    this.openClassList.pop()
                }


            }
        },
        addFn() {
            this.payList.push({});
            this.isDelShow.push(true);
        },
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },
        // 获取组件代理商和园所的值chooseDialog 值
        getDialogList(item) {
            if (item.title == '选择代理商') {
                // 切换代理商
                this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
                this.form.AgentId = item.Id
                this.initData2() //初始化部分数据
                this.getPackages(this.form.AgentId) // 获取续班项目

            } else {
                // 切换园所
                this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo

                this.form.SchoolId = item.Id
                this.initData3() //初始化部分数据

                this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址
                this.getContinuePackages(this.form.SchoolId, this.form.ProjectType) //获取续班套餐
                this.ZqwPlatform_GetClassList(this.form.SchoolId)
            }
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.schoolConsignee.ConsigneeProvId = item.ConsigneeProvince
            this.schoolConsignee.ConsigneeCityId = item.ConsigneeCity
            this.schoolConsignee.ConsigneeAreaId = item.ConsigneeArea
            this.schoolConsignee.ConsigneeAddress = item.ConsigneeAdress
            this.schoolConsignee.Consignee = item.Consignee
            this.schoolConsignee.ConsigneeTel = item.ConsigneeTel

            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel

        },
        // 选择代理商
        chooseAgent() {
            this.$refs.chooseDialog.show({
                title: '选择代理商',
                ProjectType: 3
            });

        },
        //选择园所
        chooseSchool() {
            this.form.ClassNum = 1

            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else if (this.form.ProjectType == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择项目',
                    type: 'warning'
                });
            } else {
                this.$refs.chooseDialog.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId,
                    ProjectType: this.form.ProjectType
                });

            }

        },
        //修改园所收货地址
        changeAddress() {
            this.$refs.AddressDialog.show({
                SchoolId: this.form.SchoolId,
                address: this.schoolConsignee,
                Id: this.form.SchoolConsigneeId

            });
        },
        // 创建班级
        addClass() {
            if (this.form.SchoolId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择园所',
                    type: 'warning'
                });
            } else {
                this.$refs.refAddClass.show({
                    title: '创建班级',
                    SchoolId: this.form.SchoolId
                })
            }

        },
        getClassList(item) {
            this.ZqwPlatform_GetClassList(this.form.SchoolId)
        },
        getShowData() {
            return cloneDeep({
                OrderId: 0,
                SchoolId: 0,
                title: '',
                isReadOnly: false,
                isShowBtn: false, //true显示选择代理商和园所按钮
                PreSemesterClasNum: 0, //上学期总开班数，
                ContinueClassNum: 0, //已开课数
                OverNum: 0, //历史扩班数
                PackageId: ""

            });
        },
        //初始化数据（切换园所用）
        initData3() {
            // 切换园所清空（园所，联系人，收货地址）
            this.schoolConsignee = this.getSchoolConsignee()
            this.ConsigneeList = '';
            this.ConsigneeListName = '';
            this.form.ClassId = "";
            this.Packages = []
            this.form.PackageId = '';
            this.GoodsListNum = [{
                Num: 0,
                List: [{
                    ProId: "",
                    ProNum: 30
                }]
            }];
            this.ClassLists = [] //班级列表置空
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
        },
        //初始化数据（切换代理商用）
        initData2() {
            // 切换园所清空（园所，项目，联系人，收货地址）
            this.school = ''; //园所清空
            this.form.SchoolId = '';
            this.ConsigneeList = ''; //收货地址清空
            this.ConsigneeListName = ''; //联系人清空
            this.form.ProjectType = ''; //项目清空
            this.ClassLists = [] //班级列表置空
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
        },
        //初始化数据全局
        initData() {
            this.loading = false
            this.form = this.getSubmitFormData();
            this.schoolConsignee = this.getSchoolConsignee()
            this.showData = this.getShowData();
            this.detailsPackages = [];
            this.GoodsListNum = [{
                Num: 0,
                List: [{
                    ProId: "",
                    ProNum: 30
                }]
            }]
            this.agent = "";
            this.school = "";
            this.ConsigneeList = '';
            this.ConsigneeListName = '';
            this.ContinuePackages = [];
            this.ProjectTypes = [];
            this.payList = [{}];
            this.ClassLists = []
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.boxData = []
        },
        closeFn() {
            this.AddDialogVisible = false;
        },
        show(options) {
            this.initData();

            this.showData.title = options.title;

            // 设置数据
            if (options.message) {
                this.form.AgentId = options.message.AgentId;
                this.agent = options.message.AgentName + ' , ' + options.message.C_Name + '  ' + options.message.PhoneNo;
                this.school = options.message.SchoolName;
                this.form.SchoolId = options.message.SchoolId;
                this.form.ProjectType = options.message.ProjectType;
                this.getPackages(this.form.AgentId); // 获取续班项目
                this.getSchoolConsigneeList(this.form.SchoolId); //点击园所之后获取默认收货地址
            } else {
                this.AddDialogVisible = true;
            }

            // 会销相关订单
            if (this.showData.title == '修改订单' || this.showData.title == '查看订单') {

                jToast.show({
                    type: "loading",
                    text: "正在获取数据，请稍后...",
                    time: -1
                });
                this.showData.isReadOnly = options.isReadOnly;
                this.form.OrderId = options.message.OrderId;
                this.showData.PackageId = options.message.PackageId;
                //this.form.PackageId = options.message.PackageId;
                this.getList(options.message.OrderId); //获取单条
                this.getDetailsPackage(this.showData.PackageId); // 获取套餐资源包下拉明细
                this.getContinuePackages(this.form.SchoolId, this.form.ProjectType); //获取续班套餐
            } else if (this.showData.title == '添加续班订单') {
                this.AddDialogVisible = true;
                this.showData.isShowBtn = true;
                this.showData.isReadOnly = false;
            }

        },
        submit() {
            this.form.OrderPrice = this.price;
            this.form.ProList = [{
                Num: 0,
                List: []
            }]
            this.form.OrderPostPrice = this.postage
            console.log(this.form)
            let rule = [{
                name: "代理商",
                value: this.agent,
                required: true,
                msg: '请选择代理商'
            }, {
                name: "项目",
                value: this.form.ProjectType,
                required: true,
                msg: '请选择续订项目目'
            }, {
                name: "园所",
                value: this.school,
                required: true,
                msg: '请选择续园所'
            }, {
                name: "套餐",
                value: this.form.PackageId,
                required: true,
                msg: '请选择续套餐'
            }, {
                name: "支付对象",
                value: this.form.PayObject,
                required: (this.form.PackageId !== 1151 && this.form.PackageId !== 5042),
            }];
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            // 班级列表
            this.form.ClassList = []
            if (this.form.PackageId == 5042) {
                for (let i = 0; i < this.form.ClassNum; i++) {
                    if (this.openClassList[i].ClassId !== '') {
                        this.form.ClassList.push(this.openClassList[i].ClassId)
                    }
                }
                // 判断是否提交相同的班级
                let arr = cloneDeep(this.form.ClassList)
                var nary = arr.sort();
                for (var i = 0; i < arr.length; i++) {
                    if (nary[i] == nary[i + 1]) {
                        this.$notify({
                            title: '警告',
                            message: '不能存在相同的班级',
                            type: 'warning'
                        });
                        return;

                    }
                }
            }

            if (this.form.PackageId == 399 || this.form.PackageId == 401 || this.form.PackageId == 402 || this.form.PackageId == 5042) {
                //hi幼教续订套餐
                this.form.ProList[0].List = this.Packages;
            } else if (this.form.PackageId == 405) {
                // 套餐三（续）
                for (let i = 0; i < this.GoodsListNum.length; i++) {
                    for (let k = 0; k < this.GoodsListNum[i].List.length; k++) {
                        this.GoodsListNum[i].List[k].ProNum = this.GoodsListNum[i].Num
                    }
                }
                this.form.ProList = this.GoodsListNum;
            } else {
                this.form.ProList = this.GoodsListNum;
            }
            // 判断是都选择套餐
            for (let i = 0; i < this.form.ProList.length; i++) {
                if (this.form.ProList[i].ProId == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择套餐',
                        type: 'warning'
                    });
                    return;
                }
            }
            // 支付方式
            this.form.ListMeetPay = [];
            for (let i = 0; i < this.payList.length; i++) {
                let data = this.$refs['payInfo' + (i + 1)][0].validate();
                // 价格为0时不需要填写支付信息
                if (this.form.OrderPrice > 0 && !data) {
                    return;
                }

                this.form.ListMeetPay.push(data);
            }
            // 判断是都选择套餐
            for (let i = 0; i < this.form.ProList.length; i++) {
                for (let k = 0; k < this.form.ProList[i].List.length; k++) {
                    if (this.form.ProList[i].List[k].ProId == '') {
                        this.$notify({
                            title: '警告',
                            message: '请选择套餐',
                            type: 'warning'
                        });
                        return;
                    }
                }
            }
            //判断配置的资源包数是否达配套资源包数
            if (this.totalNum < this.packagesNum && this.form.PackageId !== 402) {
                this.$notify({
                    title: '警告',
                    message: '至少需配置' + this.packagesNum + '套套资源包',
                    type: 'warning'
                });
                return;
            }

            if (this.form.PackageId == 1151) {
                //判断班级
                if (this.form.ClassId == 0) {
                    this.$notify({
                        title: '警告',
                        message: '请选择班级',
                        type: 'warning'
                    });
                    return;
                }
                if (this.form.OrderId == 0) {
                    this.getAddOrderList(); //新增下单
                } else {
                    this.getUpdateOrderList(); //修改
                }
            } else {
                this.form.ClassId = 0; //只有亲子活动有ClassId
                this.$confirm('当前为续班' + this.form.ClassNum + '个，请确定!', '提示', {}).then(() => {
                    if (this.form.OrderId == 0) {
                        this.getAddOrderList(); //新增下单
                    } else {
                        this.getUpdateOrderList(); //修改
                    }
                });
            }

        }
    },
    computed: {
        // 总资源包套数
        totalNum() {
            let num = 0
            if (this.form.PackageId == 405) {
                //套餐三（续）

                for (let i = 0; i < this.GoodsListNum.length; i++) {
                    num += this.GoodsListNum[i].Num
                }
            } else if (this.form.PackageId == 402 || this.form.PackageId == 401 || this.form.PackageId == 399 || this.form.PackageId == 5042) {

                for (let i = 0; i < this.Packages.length; i++) {
                    num += this.Packages[i].ProNum
                }
            } else {

                for (let i = 0; i < this.GoodsListNum.length; i++) {
                    num += this.GoodsListNum[i].List[0].ProNum
                }
            }

            return num;
        },
        // 邮费
        postage() {
            // A.总物料数-订单配套资源包数≤30
            if (this.form.PackageId == '' || this.totalNum == 0 || this.totalNum - this.packagesNum <= 0) {
                return 0
            } else if (this.form.ProjectType == 2 && this.form.PackageId !== 5042) {
                // hi幼教套餐除了D55续
                if (this.totalNum - this.packagesNum <= 30) {
                    return 24
                } else {
                    return ((this.totalNum - this.packagesNum) * 0.8).toFixed(2)
                }
            } else if (this.form.ProjectType == 2 && this.form.PackageId == 5042) {
                if (this.schoolConsignee.ConsigneeProvId == 131 || this.schoolConsignee.ConsigneeProvId == 132 || this.schoolConsignee.ConsigneeProvId == 133) {
                    //江浙沪地区131 132 133
                    if (this.totalNum - this.packagesNum <= 30) {
                        return 12
                    } else {
                        return ((this.totalNum - this.packagesNum) * 0.4).toFixed(2)
                    }
                } else {
                    // 非江浙沪地区
                    if (this.totalNum - this.packagesNum <= 30) {
                        return 19
                    } else {
                        return ((this.totalNum - this.packagesNum) * 0.63).toFixed(2)
                    }
                }
            } else if (this.form.ProjectType == 1) {
                return 0
            }

        },
        //资源包价格
        price() {
            if (this.form.PayObject !== '' || this.form.PackageId == 1151 || this.form.PackageId == 5042) {
                if (this.form.PackageId == 401) {
                    if (this.totalNum <= this.packagesNum) {
                        return this.UnitPrice1 * this.form.ClassNum
                    }
                    // D/E续 价格=（5500*订单续班数）+（总资源包套数-30*班级数）*48  //AddUnitprice 园所88  代理商38
                    return (this.UnitPrice1 * this.form.ClassNum) + ((this.totalNum - 30 * this.form.ClassNum) * this.AddUnitprice);
                } else if (this.form.PackageId == 402) {
                    // 全园续 15800*套餐数+【（总资源包套数-90*班级数）*16.82】//AddUnitprice 园所88  代理商38
                    if (this.totalNum <= this.packagesNum) {
                        return (this.UnitPrice2 * this.form.ClassNum).toFixed(2);
                    } else {
                        return this.UnitPrice2 * this.form.ClassNum + ((this.totalNum - 90 * this.form.ClassNum) * this.AddUnitprice);
                    }

                } else if (this.form.PackageId == 403 || this.form.PackageId == 404) {
                    // 套餐一（续） 套餐二（续）  16800*班级数+【（总资源包套数-25*班级数）*150】
                    return this.UnitPrice3 * this.form.ClassNum + ((this.totalNum - 25 * this.form.ClassNum) * 150);
                } else if (this.form.PackageId == 405) {
                    //套餐三（续）
                    // 33600*班级数+【（艺术总资源包套数-25*班级数）*282+（除艺术外其他总资源包套数-50*班级数）*150】
                    return this.UnitPrice4 * this.form.ClassNum + (this.totalNum - 25 * this.form.ClassNum) * 282 + (this.totalNum * 2 - 50 * this.form.ClassNum) * 150;
                } else if (this.form.PackageId == 1151) {
                    // 亲子活动 282*下单的资源包套数
                    return 282 * this.totalNum;
                } else if (this.form.PackageId == 399) {
                    // 园所支付价格 = 3500 * 班级数 +【（总资源包数 - 班级数 * 15）* 88】
                    // 代理商支付价格 = 2750 * 班级数 +【（总资源包数 - 班级数 * 15）* 38】
                    if (this.totalNum <= this.packagesNum) {
                        return this.UnitPriceHiA * this.form.ClassNum
                    }
                    return this.UnitPriceHiA * this.form.ClassNum + ((this.totalNum - 15 * this.form.ClassNum) * this.AddUnitprice);
                } else if (this.form.PackageId == 5042) {
                    // D55续 5042订单价格=7000*班级数+【（总物料数-30*班级数）*17.3】
                    if (this.totalNum <= this.packagesNum) {
                        return 7000 * this.form.ClassNum
                    }
                    return (7000 * this.form.ClassNum + ((this.totalNum - 30 * this.form.ClassNum) * 17.3)).toFixed(2);

                }
            }

            return 0

        },
        totalPrice() {
            return (this.postage * 1 + this.price * 1).toFixed(2)
        },
        // 至少配置资源包总数
        packagesNum() {
            if (this.form.PackageId == 401 || this.form.PackageId == 5042) {
                //单班续一个班30套 D55续
                return 30 * this.form.ClassNum;
            } else if (this.form.PackageId == 402) {
                // 全园续 一个套餐90套
                return 90 * this.form.ClassNum;
            } else if (this.form.PackageId == 403 || this.form.PackageId == 404) {
                // 套餐一（续） 套餐二（续）  一个班25套英语学习材料
                return 25 * this.form.ClassNum;
            } else if (this.form.PackageId == 405) {
                //套餐三（续）一个班25套英语/25套思维/25套艺术
                return 25 * this.form.ClassNum;
            } else if (this.form.PackageId == 1151) {
                // 亲子活动 最少5套
                return 5 * this.form.ClassNum;
            } else if (this.form.PackageId == 399) {
                // HiA 最少15套
                return 15 * this.form.ClassNum;
            }
            return 0
        },
        minNum() {
            if (this.form.PackageId == 401) {
                //单班续一个班30套
                return 30
            } else if (this.form.PackageId == 402) {
                // 全园续 一个套餐90套
                return 90
            } else if (this.form.PackageId == 403 || this.form.PackageId == 404) {
                // 套餐一（续） 套餐二（续）  一个班25套英语学习材料
                return 25
            } else if (this.form.PackageId == 405) {
                //套餐三（续）一个班25套英语/25套思维/25套艺术
                return 25
            } else if (this.form.PackageId == 1151) {
                // 亲子活动 最少5套
                return 5
            }
            return 0
        },
        maxNumPackage() {
            if (this.form.PackageId == 403 || this.form.PackageId == 404 || this.form.PackageId == 405) {
                return 31
            } else {
                return Infinity
            }
        },

    },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/BookPackage/ContinueOrderDialog/vm.js